import { cloneDeep } from 'lodash';
import { toothUtils } from '@/features/tooth/lib/toothUtils';

export const selectDenteMixin = {
    props: {
        defaultSelected: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            required: true
        },
        tipoSelect: {
            type: String,
            required: true
        },
        numeroDente: {
            type: Number,
            required: true
        },
        size: {
            type: Number,
            default: 100
        }
    },
    watch: {
        defaultSelected: {
            handler(newVal) {
                this.selected = newVal;
                this.refreshSelectedElements(cloneDeep(newVal));
            },
            deep: true
        },
        options: {
            handler(newVal) {
                this.refreshOptionElements(cloneDeep(newVal));
            },
            deep: true
        }
    },
    data() {
        return {
            selected: cloneDeep(this.defaultSelected)
        }
    },
    computed: {
        detalhesDente() {
            return toothUtils.getToothDetails(Number(this.numeroDente));
        }
    },
    methods: {
        selectSection(event) {
            const sectionElement = event.target?.getAttribute('data-id') ? event.target : event.target?.parentElement;
            if (!sectionElement)
                return;
            const sectionId = sectionElement.getAttribute('data-id');
            if (!sectionId)
                return;
            if (sectionElement.getAttribute('data-disabled') == 'true')
                return;

            if (this.selected.includes(sectionId)) {
                this.selected = this.selected.filter(s => s !== sectionId);
            } else {
                this.selected.push(sectionId);
            }
            this.$emit('selectChange', this.selected);
            this.refreshSelectedElements(this.selected);
        },
        refreshSelectedElements(selected) {
            this.$nextTick(() => {
                this.$el.querySelectorAll('g.section').forEach(section => {
                    section.setAttribute('data-selected', selected.includes(section.getAttribute('data-id')));
                });
            });
        },
        refreshOptionElements(options) {
            this.$nextTick(() => {
                this.$el.querySelectorAll('g.section').forEach(section => {
                    section.setAttribute('data-disabled', !options.includes(section.getAttribute('data-id')));
                });
            });
        },
        registerEventListeners() {
            this.$nextTick(() => {
                this.$el.querySelectorAll('g.section').forEach(section => {
                    section.addEventListener('click', this.selectSection);
                });
            });
        },
        unregisterEventListeners() {
            this.$el.querySelectorAll('g.section').forEach(section => {
                section.removeEventListener('click', this.selectSection);
            });
        }
    },

    mounted() {
        this.refreshSelectedElements(this.selected);
        this.refreshOptionElements(this.options);
        setTimeout(() => {
            this.registerEventListeners();
        }, 200);
    },

    beforeDestroy() {
        this.unregisterEventListeners();
    }
};